module.exports = __webpack_public_path__ + "static/media/24UHCHR6.a177eff2.jpg";